import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Tooltip,
  IconButton,
  Box,
  Tabs,
  Tab,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";

interface ServiceProvider {
  id: number;
  name: string;
  email: string;
  phone: string;
  status: string;
  totalBookings: number;
}

function ProviderList() {
  const navigate = useNavigate();

  const [providers, setProviders] = useState<ServiceProvider[]>([
    {
      id: 1,
      name: "Salon Elegance",
      email: "info@salonelegance.com",
      phone: "+91 8999282921",
      status: "Pending",
      totalBookings: 12,
    },
    {
      id: 2,
      name: "Barber King",
      email: "contact@barberking.com",
      phone: "+91 7889011223",
      status: "Accepted",
      totalBookings: 30,
    },
    {
      id: 3,
      name: "Style Studio",
      email: "studio@style.com",
      phone: "+91 7001122334",
      status: "Rejected",
      totalBookings: 5,
    },
    {
      id: 4,
      name: "Glow & Shine",
      email: "support@glowshine.com",
      phone: "+91 8112233445",
      status: "Pending",
      totalBookings: 8,
    },
    {
      id: 5,
      name: "Luxury Cuts",
      email: "luxury@cuts.com",
      phone: "+91 7665544332",
      status: "Accepted",
      totalBookings: 25,
    },
    {
      id: 6,
      name: "Urban Styles",
      email: "urban@styles.com",
      phone: "+91 9556677880",
      status: "Rejected",
      totalBookings: 3,
    },
    {
      id: 7,
      name: "Elite Salon",
      email: "elite@salon.com",
      phone: "+91 9445566778",
      status: "Pending",
      totalBookings: 14,
    },
    {
      id: 8,
      name: "Trendy Tresses",
      email: "contact@trendytresses.com",
      phone: "+91 9887766554",
      status: "Accepted",
      totalBookings: 41,
    },
    {
      id: 9,
      name: "Chic Hair Lounge",
      email: "info@chichair.com",
      phone: "+91 9771122334",
      status: "Rejected",
      totalBookings: 2,
    },
    {
      id: 10,
      name: "Beauty Hub",
      email: "beauty@hub.com",
      phone: "+91 9334455667",
      status: "Pending",
      totalBookings: 20,
    },
  ]);

  const [activeTab, setActiveTab] = useState("Pending");

  // ✅ handle dropdown change
  const handleStatusChange = (id: number, newStatus: string) => {
    setProviders((prev) =>
      prev.map((p) => (p.id === id ? { ...p, status: newStatus } : p))
    );
  };

  const [searchTerm, setSearchTerm] = useState("");

  // ✅ filter based on active tab
  const filteredProviders = providers.filter(
    (p) => p.status === activeTab && p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          {/* ✅ Tabs Section */}
          <Box className="custom_tabs1" sx={{ width: "100%", marginBottom: 2 }}>
            <Tabs
              value={activeTab}
              onChange={(_, newValue) => setActiveTab(newValue)}
              textColor="primary"
              className="custom_tabs_links"
              indicatorColor="primary"
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              <Tab className={activeTab === "Pending" ? "active" : ""} label="Pending" value="Pending" />
              <Tab className={activeTab === "Accepted" ? "active" : ""} label="Accepted" value="Accepted" />
              <Tab className={activeTab === "Rejected" ? "active" : ""} label="Rejected" value="Rejected" />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-service-providers/edit")}
            >
              <AddIcon /> Add Provider
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Total Bookings</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredProviders.map((provider) => (
                <TableRow key={provider.id}>
                  <TableCell>
                    <a
                      href="/manage-service-providers/view"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/manage-service-providers/view", { state: { provider } });
                      }}
                      className="user_block click_action"
                    >
                      <figure>
                        <img
                          src="/static/images/user_placeholder.png"
                          alt={provider.name}
                        />
                      </figure>
                      <p>
                        <b>{provider.name}</b>
                        <span>{provider.email}</span>
                        <span>{provider.phone}</span>
                      </p>
                    </a>

                  </TableCell>

                  {/* ✅ Status dropdown */}
                  <TableCell>
                    <div className="form">
                      <Select
                        fullWidth
                        value={provider.status}
                        onChange={(e) =>
                          handleStatusChange(provider.id, e.target.value)
                        }
                      >
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Accepted">Accepted</MenuItem>
                        <MenuItem value="Rejected">Rejected</MenuItem>
                      </Select>
                    </div>
                  </TableCell>

                  <TableCell>{provider.totalBookings}</TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <Box>
                        <Tooltip title="Edit Provider" arrow>
                          <IconButton
                            onClick={() =>
                              navigate("/manage-service-providers/edit", {
                                state: { provider },
                              })
                            }
                          >
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Edit"
                            />
                          </IconButton>
                        </Tooltip>
                      </Box>
                      <Box>
                        <Tooltip title="View Provider Details" arrow>
                          <IconButton
                            onClick={() =>
                              navigate("/manage-service-providers/view", {
                                state: { provider },
                              })
                            }
                          >
                            <img src="/static/images/eye_icon.svg" alt="View" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

export default ProviderList;
